import { Panel, Pipeline } from 'components/ideal-core-ui'
import { FaColumns } from 'react-icons/fa'

const PipelineSettings = () => {
  return (
    <Panel
      styles={{ marginBottom: '30px' }}
      title="Pipeline Stages and Settings"
      titleIcon={<FaColumns />}
      hasInnerPadding
    >
      <Pipeline
        url="/v1/dealstatus/user"
        texts={{
          title:
            'Select which pipeline stages you want to see on the Opportunities board and order them.'
        }}
      />
    </Panel>
  )
}

export default PipelineSettings
